<app-navbar
  [menuItems]="menuItems()"
  [popoverButtons]="popoverButtons()"
  [hideLogo]="true"
  class="py-2 px-7 max-w-screen-xl mx-auto"
/>
